<lua-snackbar
	[type]="type"
	[position]="position"
	[message]="message"
	[iconName]="iconName"
	[buttonText]="buttonText"
	[buttonIconName]="buttonIconName"
	[delay]="delay"
></lua-snackbar>
